export const localKeyGenByVedaKeysOfFlexOrderField = 'KeyGenByVedaKeysOfFlexOrderField';
